import { CircularProgressProps } from '@material-ui/core/CircularProgress';

const MuiCircularProgress: CircularProgressProps = {
    size: 32,
};

export default MuiCircularProgress;
